import React from "react"
import { CookiesProvider } from "react-cookie"
import "./src/styles/global.css"

export const wrapRootElement = ({ element }) => (
  <CookiesProvider>{element}</CookiesProvider>
)